import { memo } from 'react'

import View from './AccountControls.view'

export interface ControllerProps {
  className?: string
}

export const Controller = memo(function AccountControlsController({ className }: ControllerProps) {
  return <View className={className} />
})

Controller.displayName = 'AccountControls_Controller'
